"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.permissionsData = exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactRedux = require("react-redux");
var _classnames = _interopRequireDefault(require("classnames"));
var _get2 = _interopRequireDefault(require("lodash/get"));
var _cccisdApollo = require("cccisd-apollo");
var _cccisdGraphqlTable = _interopRequireDefault(require("cccisd-graphql-table"));
var _cccisdHiddenBlock = _interopRequireDefault(require("cccisd-hidden-block"));
var _cccisdLoader = _interopRequireDefault(require("cccisd-loader"));
var _cccisdModal = _interopRequireDefault(require("cccisd-modal"));
var _cccisdTooltip = _interopRequireDefault(require("cccisd-tooltip"));
var _Header = _interopRequireDefault(require("../../components/Header"));
var _LackingPermissions = _interopRequireDefault(require("../../components/LackingPermissions"));
var _questPermissionsByArea = _interopRequireDefault(require("../../helpers/questPermissionsByArea.js"));
var _admin = require("../../selectors/admin.js");
var _AddPawnRule = _interopRequireDefault(require("./AddPawnRule"));
var _pawnsWithPermissions = _interopRequireDefault(require("./pawnsWithPermissions.graphql"));
var _pawnsWithPermissionsAsSuper = _interopRequireDefault(require("./pawnsWithPermissionsAsSuper.graphql"));
var _permissionIds = _interopRequireDefault(require("./permissionIds.graphql"));
var _rolePermissions = _interopRequireDefault(require("./rolePermissions.graphql"));
var _tableRenderPawnPermissionEdit = _interopRequireDefault(require("./tableRenderPawnPermissionEdit.js"));
var _tableRenderRolePermissionEdit = _interopRequireDefault(require("./tableRenderRolePermissionEdit.js"));
var _style = _interopRequireDefault(require("./style.css"));
var _plus = _interopRequireDefault(require("cccisd-icons/plus2"));
var _checkmark = _interopRequireDefault(require("cccisd-icons/checkmark"));
var _palette = _interopRequireDefault(require("cccisd-icons/palette"));
var _paperplane = _interopRequireDefault(require("cccisd-icons/paperplane"));
var _meterMedium = _interopRequireDefault(require("cccisd-icons/meter-medium"));
var _listNumbered = _interopRequireDefault(require("cccisd-icons/list-numbered"));
var _fileSpreadsheet = _interopRequireDefault(require("cccisd-icons/file-spreadsheet2"));
var _userLock = _interopRequireDefault(require("cccisd-icons/user-lock"));
var _cog = _interopRequireDefault(require("cccisd-icons/cog2"));
var _envelop = _interopRequireDefault(require("cccisd-icons/envelop3"));
var _copy = _interopRequireDefault(require("cccisd-icons/copy3"));
var _userCheck = _interopRequireDefault(require("cccisd-icons/user-check"));
var _pencil = _interopRequireDefault(require("cccisd-icons/pencil"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var method = delegate.iterator[context.method]; if (undefined === method) { if (context.delegate = null, "throw" === context.method) { if (delegate.iterator["return"] && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel; context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method"); } return ContinueSentinel; } var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) { if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; } return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) { keys.push(key); } return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) { "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); } }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, "catch": function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var AppDefs = window.cccisd.appDefs;
var Fortress = window.cccisd.fortress;

/*
 * permissionsData is used by many other files in this page. The order of the
 * entries is important.
 */
var permissionsData = [{
  alias: 'design',
  permission: 'quest.design',
  labelIcon: _palette["default"],
  tooltip: 'Design tab access',
  topHeader: 'Tabs',
  topHeaderSpan: 8,
  formLabel: 'Design',
  toggleFieldAliasesWhenSet: ['copySurveys']
}, {
  alias: 'deploy',
  permission: 'quest.deploy',
  labelIcon: _paperplane["default"],
  tooltip: 'Deploy tab access',
  formLabel: 'Deploy',
  toggleFieldAliasesWhenSet: ['messaging']
}, {
  alias: 'status',
  permission: 'quest.status',
  labelIcon: _meterMedium["default"],
  tooltip: 'Progress tab access',
  formLabel: 'Progress'
}, {
  alias: 'code',
  permission: 'quest.code',
  labelIcon: _listNumbered["default"],
  tooltip: 'Code tab access',
  formLabel: 'Code'
}, {
  alias: 'viewData',
  permission: 'quest.view_data',
  labelIcon: _fileSpreadsheet["default"],
  tooltip: 'Data tab access',
  formLabel: 'Data'
}, {
  alias: 'permissions',
  permission: 'quest.permissions',
  labelIcon: _userLock["default"],
  tooltip: 'Permissions tab access',
  formLabel: 'Permissions'
}, {
  alias: 'admin',
  permission: 'quest.admin',
  labelIcon: _cog["default"],
  tooltip: 'Full control over this Quest Project, including Manage Projects tab access and ability to set permissions',
  formLabel: 'Full control over this Quest Project',
  toggleFieldAliasesWhenSet: ['design', 'deploy', 'status', 'code', 'viewData', 'permissions', 'messaging', 'copySurveys', 'modifyData']
}, {
  alias: 'copySurveys',
  permission: 'quest.copy_surveys',
  labelIcon: _copy["default"],
  tooltip: 'Copy surveys from this project into other projects',
  topHeader: 'Permissions',
  topHeaderSpan: 5
}, {
  alias: 'messaging',
  permission: 'quest.messaging',
  labelIcon: _envelop["default"],
  tooltip: 'Access exported Messaging area'
}, {
  alias: 'viewIdentifiableData',
  permission: 'quest.view_identifiable_data',
  labelIcon: _userCheck["default"],
  tooltip: 'View identifiable data'
}, {
  alias: 'modifyData',
  permission: 'quest.modify_data',
  labelIcon: _pencil["default"],
  tooltip: 'Modify/delete data'
}];
exports.permissionsData = permissionsData;
var Permissions = function Permissions() {
  var _useState = (0, _react.useState)(true),
    _useState2 = _slicedToArray(_useState, 2),
    loading = _useState2[0],
    setLoading = _useState2[1];
  var _useState3 = (0, _react.useState)({}),
    _useState4 = _slicedToArray(_useState3, 2),
    graphqlPermissionVariables = _useState4[0],
    setGraphqlPermissionVariables = _useState4[1];
  var project = (0, _reactRedux.useSelector)(function (state) {
    return (0, _admin.getCurrentProject)(state.assignment.admin);
  }) || {};
  var canManage = Fortress.hasAnyAccess(_questPermissionsByArea["default"].manage.permissions, project.groupId);

  /* /////////////////////////////////////////////////////////////////////////
  // LIFECYCLE //////////////////////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////// */

  (0, _react.useEffect)(function () {
    function loadPermissionIds() {
      return _loadPermissionIds.apply(this, arguments);
    }
    function _loadPermissionIds() {
      _loadPermissionIds = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var response, responsePermissionList, updatedVariables;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _cccisdApollo.client.query({
                  query: _permissionIds["default"],
                  fetchPolicy: 'network-only'
                });
              case 2:
                response = _context.sent;
                responsePermissionList = (0, _get2["default"])(response, 'data.roles.permissionList');
                updatedVariables = {};
                permissionsData.forEach(function (p) {
                  var responsePermission = responsePermissionList.find(function (rp) {
                    return rp.permission === p.permission;
                  });
                  updatedVariables["".concat(p.alias, "PermId")] = responsePermission ? responsePermission.permissionId : 0;
                });
                setGraphqlPermissionVariables(updatedVariables);
                setLoading(false);
              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
      return _loadPermissionIds.apply(this, arguments);
    }
    loadPermissionIds();
  }, []);

  /* /////////////////////////////////////////////////////////////////////////
  // ADD RULE–RELATED ///////////////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////// */

  var addPawnRuleButton = function addPawnRuleButton(loadData) {
    return /*#__PURE__*/_react["default"].createElement(_cccisdModal["default"], {
      trigger: /*#__PURE__*/_react["default"].createElement("button", {
        type: "button",
        className: "btn btn-primary"
      }, /*#__PURE__*/_react["default"].createElement("span", {
        className: _style["default"].iconSpace
      }, /*#__PURE__*/_react["default"].createElement(_plus["default"], null)), "Add People"),
      render: function render(_ref) {
        var closeModal = _ref.closeModal;
        return /*#__PURE__*/_react["default"].createElement(_AddPawnRule["default"], {
          closeModal: closeModal,
          loadData: loadData
        });
      },
      size: "large",
      title: "Add People to ".concat(project.label)
    });
  };

  /* /////////////////////////////////////////////////////////////////////////
  // PAWN TABLE-RELATED /////////////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////// */

  var appdefRoles = AppDefs.pawn.roles || [];
  var roleFilterOptions = appdefRoles.map(function (p) {
    return {
      label: p.label,
      value: p.handle
    };
  });
  var actionsColumn = [{
    name: 'actions',
    label: 'Actions',
    render: _tableRenderPawnPermissionEdit["default"]
  }];
  var baseColumns = [{
    name: 'user.username',
    label: 'Username',
    sort: true,
    filter: true
  }, {
    name: 'user.firstName',
    label: 'First Name',
    sort: true,
    filter: true
  }, {
    name: 'user.lastName',
    label: 'Last Name',
    sort: true,
    filter: true
  }, {
    name: 'parentGroup.anyGroup.group.label',
    label: 'Group',
    sort: true,
    filter: true
  }, {
    name: 'pawn.role',
    label: 'Role',
    sort: true,
    filter: true,
    filterSettings: {
      type: 'selectbox',
      options: roleFilterOptions
    },
    render: function render(_ref2) {
      var value = _ref2.value;
      var roleDef = appdefRoles.find(function (r) {
        return r.handle === value;
      });
      return roleDef ? roleDef.label : value;
    }
  }];
  var permissionColumns = permissionsData.map(function (p) {
    var LabelIcon = p.labelIcon;
    var label = /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
      title: p.tooltip
    }, /*#__PURE__*/_react["default"].createElement(LabelIcon, null));
    return {
      name: "".concat(p.alias, "Perm"),
      label: label,
      className: 'text-center',
      sort: false,
      topHeader: p.topHeader || null,
      topHeaderSpan: p.topHeaderSpan || null,
      filter: true,
      filterSettings: {
        type: 'selectbox',
        options: [{
          label: 'Y',
          value: '1'
        }, {
          label: 'N',
          value: '0'
        }]
      },
      render: function render(_ref3) {
        var row = _ref3.row;
        var pawnPerm = !!(0, _get2["default"])(row, "".concat(p.alias, "PawnPerm.permission"));
        var pawnTarget = !!(0, _get2["default"])(row, "".concat(p.alias, "PawnPerm.targetId"));
        var rolePerm = !!(0, _get2["default"])(row, "".concat(p.alias, "RolePerm.permission"));
        var showInverse = pawnPerm && !pawnTarget || rolePerm;
        var hasPermission = pawnPerm || rolePerm;
        return hasPermission ? /*#__PURE__*/_react["default"].createElement("span", {
          className: showInverse ? _style["default"].showInverse : null
        }, /*#__PURE__*/_react["default"].createElement(_checkmark["default"], null)) : null;
      }
    };
  });
  var pawnTableColumns = [].concat(baseColumns, _toConsumableArray(permissionColumns));
  if (canManage) {
    pawnTableColumns = [].concat(actionsColumn, _toConsumableArray(pawnTableColumns));
  }

  /* /////////////////////////////////////////////////////////////////////////
  // ROLE TABLE-RELATED /////////////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////// */

  var roleBaseColumns = [{
    name: 'label',
    label: 'Role',
    sort: false,
    filter: false
  }];
  var rolePermissionColumns = permissionsData.map(function (p) {
    var LabelIcon = p.labelIcon;
    var label = /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
      title: p.tooltip
    }, /*#__PURE__*/_react["default"].createElement(LabelIcon, null));
    return {
      name: "".concat(p.alias, "Perm"),
      label: label,
      className: 'text-center',
      sort: false,
      topHeader: p.topHeader || null,
      topHeaderSpan: p.topHeaderSpan || null,
      filter: true,
      filterSettings: {
        type: 'selectbox',
        options: [{
          label: 'Y',
          value: '1'
        }, {
          label: 'N',
          value: '0'
        }]
      },
      render: function render(_ref4) {
        var row = _ref4.row;
        var rolePerm = !!(0, _get2["default"])(row, "".concat(p.alias, "RolePerm.permission"));
        var roleTarget = !!(0, _get2["default"])(row, "".concat(p.alias, "RolePerm.targetId"));
        return rolePerm ? /*#__PURE__*/_react["default"].createElement("span", {
          className: !roleTarget ? _style["default"].showInverse : null
        }, /*#__PURE__*/_react["default"].createElement(_checkmark["default"], null)) : null;
      }
    };
  });
  var roleTableColumns = function roleTableColumns(outerLoadData) {
    var roleActionsColumn = {
      name: 'actions',
      label: 'Actions',
      render: (0, _tableRenderRolePermissionEdit["default"])({
        outerLoadData: outerLoadData,
        project: project
      })
    };
    return [roleActionsColumn].concat(roleBaseColumns, _toConsumableArray(rolePermissionColumns));
  };
  var includeRoles = appdefRoles.filter(function (r) {
    return r.isFortressUser && !['respondent'].includes(r.handle);
  }).map(function (r) {
    return r.handle;
  });

  /* /////////////////////////////////////////////////////////////////////////
  // RENDER-RELATED /////////////////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////// */

  var legend = /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('pull-right', _style["default"].legend)
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: _style["default"].checkmarkPadding
  }, /*#__PURE__*/_react["default"].createElement(_checkmark["default"], null)), ": individually granted permission", /*#__PURE__*/_react["default"].createElement("br", null), /*#__PURE__*/_react["default"].createElement("span", {
    className: _style["default"].showInverse
  }, /*#__PURE__*/_react["default"].createElement(_checkmark["default"], null)), ": system-granted permission");
  var renderMainTable = function renderMainTable(_ref5) {
    var loadData = _ref5.loadData,
      renderDefault = _ref5.renderDefault;
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
      className: _style["default"].headerBlock
    }, /*#__PURE__*/_react["default"].createElement("h2", {
      style: {
        display: 'inline-block'
      }
    }, "People"), canManage && addPawnRuleButton(loadData)), renderDefault(), legend, canManage && /*#__PURE__*/_react["default"].createElement("div", {
      className: _style["default"].bottomTableWrapper
    }, /*#__PURE__*/_react["default"].createElement(_cccisdHiddenBlock["default"], {
      title: "Advanced"
    }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("h2", {
      style: {
        display: 'inline-block'
      }
    }, "Roles")), /*#__PURE__*/_react["default"].createElement(_cccisdGraphqlTable["default"], {
      key: "permissions",
      columns: roleTableColumns(loadData),
      query: _rolePermissions["default"],
      rowKey: "handle",
      graphqlVariables: _objectSpread({
        includeRoles: includeRoles,
        projectId: project.groupId,
        permissions: permissionsData.map(function (p) {
          return p.permission;
        })
      }, graphqlPermissionVariables)
    }), legend)));
  };

  /* /////////////////////////////////////////////////////////////////////////
  // RENDER /////////////////////////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////// */

  if (!project.groupId || !Fortress.hasAnyAccess(_questPermissionsByArea["default"].permissions.permissions, project.groupId)) {
    return /*#__PURE__*/_react["default"].createElement(_LackingPermissions["default"], null);
  }
  if (loading) {
    return /*#__PURE__*/_react["default"].createElement(_cccisdLoader["default"], {
      loading: true
    });
  }
  var isSuperUser = Fortress && Fortress.isSuperUser();
  return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_Header["default"], {
    showProjectDropdown: true,
    showQuestCount: false
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].tableWrapper
  }, /*#__PURE__*/_react["default"].createElement(_cccisdGraphqlTable["default"], {
    key: "permissions",
    columns: pawnTableColumns,
    query: isSuperUser ? _pawnsWithPermissionsAsSuper["default"] : _pawnsWithPermissions["default"],
    rowKey: "pawn.pawnId",
    graphqlVariables: _objectSpread({
      projectId: project.groupId,
      permissions: permissionsData.map(function (p) {
        return p.permission;
      })
    }, graphqlPermissionVariables),
    render: renderMainTable
  })));
};
var _default = Permissions;
exports["default"] = _default;